// log
import store from "../store";

const fetchDataSubRequest = () => {
  return {
    type: "CHECK_DATASUB_REQUEST",
  };
};

const fetchDataSubSuccess = (payload) => {
  return {
    type: "CHECK_DATASUB_SUCCESS",
    payload: payload,
  };
};

const fetchDataSubFailed = (payload) => {
  return {
    type: "CHECK_DATASUB_FAILED",
    payload: payload,
  };
};

export const fetchDataSub = (account) => {
  return async (dispatch) => {
    dispatch(fetchDataSubRequest());
    try {
      // let balanceOf = await store
      //   .getState()
      //   .blockchain.smartContract.methods.balanceOf(account)
      //   .call();
      let balanceOf = 0;
      let maxMintsPerWL = await store
        .getState()
        .blockchain.smartContract.methods.maxMintsPerWL()
        .call();
      let maxMintsPerPS = await store
        .getState()
        .blockchain.smartContract.methods.maxMintsPerPS()
        .call();
      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      dispatch(
        fetchDataSubSuccess({
          balanceOf,
          maxMintsPerWL,
          maxMintsPerPS,
          // cost,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataSubFailed("Could not load data from contract."));
    }
  };
};
